import CustomSelect from "@/components/CustomSelect";
import ReactPaginate from "react-paginate";
import { ResultItem } from "@/components/DrmPfInformationSearch/ResultItem";
import React from "react";
import { DrmPfInformationHooks } from "@/types/drmPfInformation";

export const SearchResultsContainer = ( { drmPfInformationHooks }: { drmPfInformationHooks: DrmPfInformationHooks } ) => {
  return (
    <>
      <div className="drmPfInformation-search-sub-title uk-flex uk-flex-between margin-top-35" ref={drmPfInformationHooks.onClickSearchScrollRef}>
        <p className="uk-drmPfInformation-text-medium-l uk-text-bold">
          検索結果：{drmPfInformationHooks.displayDrmPfInformationList.length}件中 {drmPfInformationHooks.firstItemNum + 1}~{drmPfInformationHooks.lastItemNum}件目
        </p>
        <div className="uk-flex uk-flex-middle">
          <p className="uk-text-default uk-text-bold" translate="no">表示件数：</p>
          <CustomSelect
            options={pageSizeOptions}
            value={drmPfInformationHooks.pageSize}
            onChange={drmPfInformationHooks.onChangePageSize}
            className="height-24"
          />
          <p className="uk-text-default uk-text-bold uk-margin-small-left">
            並び順：
          </p>
          <CustomSelect
            options={[{ value: "1", label: "公開日" }, { value: "2", label: "閲覧数" }]}
            value={drmPfInformationHooks.order}
            onChange={e => drmPfInformationHooks.setOrder(e.target.value)}
            className="height-24"
          />
        </div>
      </div>
      <div className="uk-flex uk-flex-center@m uk-margin-small-top uk-margin-small-bottom">
        <a className="pagination-button" onClick={drmPfInformationHooks.goToFirstPage}>&lt;&lt;</a>
        <ReactPaginate
          pageRangeDisplayed={3}
          marginPagesDisplayed={1}
          pageCount={Math.ceil(drmPfInformationHooks.displayDrmPfInformationList.length / Number(drmPfInformationHooks.pageSize))}
          onPageChange={drmPfInformationHooks.onChangePage}
          forcePage={String(drmPfInformationHooks.currentPage).length > 0 ? drmPfInformationHooks.currentPage : undefined}
          renderOnZeroPageCount={null}
          containerClassName="pagination"
          previousLabel="<"
          nextLabel=">"
          breakLabel="..."
        />
        <a className="pagination-button" onClick={drmPfInformationHooks.goToLastPage}>&gt;&gt;</a>
      </div>
      <div className="drmPfInformation-search-result">
        {drmPfInformationHooks.currentDrmPfInformationList.map(( drmPfInformation, index ) => <ResultItem drmPfInformation={drmPfInformation} index={index} key={index}/>)}
      </div>
      <div className="uk-flex uk-flex-center@m uk-margin-small-top">
        <a className="pagination-button" onClick={drmPfInformationHooks.goToFirstPage}>&lt;&lt;</a>
        <ReactPaginate
          pageRangeDisplayed={3}
          marginPagesDisplayed={1}
          pageCount={Math.ceil(drmPfInformationHooks.displayDrmPfInformationList.length / Number(drmPfInformationHooks.pageSize))}
          onPageChange={drmPfInformationHooks.onChangePage}
          forcePage={String(drmPfInformationHooks.currentPage).length > 0 ? drmPfInformationHooks.currentPage : undefined}
          renderOnZeroPageCount={null}
          containerClassName="pagination"
          previousLabel="<"
          nextLabel=">"
          breakLabel="..."
        />
        <a className="pagination-button" onClick={drmPfInformationHooks.goToLastPage}>&gt;&gt;</a>
      </div>
    </>
  )
}


const pageSizeOptions = [
  { value: "10", label: "10件" },
  { value: "20", label: "20件" },
  { value: "50", label: "50件" },
  { value: "100", label: "100件" }
]